import { faCog, faHome, faSignOutAlt } from '@fortawesome/free-solid-svg-icons'
import React from 'react'

import { Navigator } from 'ui/Templates'

export const AdminProfileNav: React.FC = () => (
  <Navigator.Drawer relative={true}>
    <Navigator.Item to="/app/dashboard" label="Dashboard" icon={faHome} />
    <Navigator.Item to="/app/settings" label="Settings" icon={faCog} />
    <Navigator.Item to="/app/logout" label="Logout" icon={faSignOutAlt} />
  </Navigator.Drawer>
)
